export default __webpack_public_path__ + "static/media/pharox-menu-logo.932cf8ae.svg";